export const Footer = () => {
  return (
    <footer className="py-12 relative overflow-hidden">
      <div className="absolute top-0 left-[10%] right-[10%] h-px" style={{ background: 'linear-gradient(90deg, transparent, hsl(var(--coral-bright) / 0.15), hsl(var(--cyan-bright) / 0.15), transparent)' }} />

      <div className="section-container relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <img src="/favicon.png" alt="Clawbiz" className="w-5 h-5 rounded-sm" />
            <span className="font-display font-medium text-lg">Clawbiz</span>
          </div>
          <nav className="flex flex-wrap justify-center gap-6 text-sm text-muted-foreground">
            <a href="#services" className="hover:text-primary transition-colors">Services</a>
            <a href="#process" className="hover:text-primary transition-colors">How It Works</a>
            <a href="#integrations" className="hover:text-primary transition-colors">Integrations</a>
            <a href="#faq" className="hover:text-primary transition-colors">FAQ</a>
            <a href="#contact" className="hover:text-primary transition-colors">Contact</a>
          </nav>
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Clawbiz. Your AI, handled for you.
          </p>
        </div>
      </div>
    </footer>
  );
};
